import { Modal } from 'antd';
import { Check, LoaderCircle, Sparkles } from 'lucide-react';

import { useDevice } from '../../../hooks/useDevice';
import { formatPrice } from '../helpers';

import styles from '../index.module.scss';

function CostLine({ quote, hasCode }) {
    if (quote.loading && !quote.data) {
        return (
            <p>
                <LoaderCircle className={styles.spin} size={15} aria-hidden />
                正在查询价格…
            </p>
        );
    }
    const price = formatPrice(quote.data?.price);
    if (!price) {
        return <p>确认后显示付款码，支付金额以付款页为准。</p>;
    }
    return (
        <p>
            本次需支付 <strong className={styles.costPrice}>{price}</strong>
            {hasCode ? '，可直接使用已带入的答辩PPT兑换码' : '，也可以使用答辩PPT兑换码或金额码'}
        </p>
    );
}

export default function ConfirmModal({
    open,
    rows,
    quote,
    queued,
    hasCode,
    submitting,
    hint,
    onCancel,
    onConfirm,
}) {
    const { isMobile } = useDevice();

    return (
        <Modal
            open={open}
            title="确认生成"
            footer={null}
            width={isMobile ? 'calc(100% - 24px)' : 520}
            centered
            maskClosable={!submitting}
            closable={!submitting}
            onCancel={submitting ? undefined : onCancel}
            className={styles.confirmModal}
        >
            <dl className={styles.confirmList}>
                {rows.map(([label, value]) => (
                    <div key={label}>
                        <dt>{label}</dt>
                        <dd>{value}</dd>
                    </div>
                ))}
            </dl>

            <div className={styles.costBox}>
                <CostLine quote={quote} hasCode={hasCode} />
            </div>

            {queued ? (
                <p className={styles.confirmHint}>
                    资料还在整理中。确认后可以先完成支付，然后离开页面，整理完成会自动开始生成；整理失败不会开始生成。
                </p>
            ) : null}
            <p className={styles.confirmNote}>
                <Check size={14} aria-hidden />
                支付后开始生成；生成失败可以免费重试，不会重复收费。生成通常需要 2–8
                分钟，页数越多越久。
            </p>
            {hint ? (
                <p className={styles.confirmHint} role="status">
                    {hint}
                </p>
            ) : null}

            <div className={styles.modalActions}>
                <button
                    type="button"
                    className={styles.secondaryButton}
                    disabled={submitting}
                    onClick={onCancel}
                >
                    取消
                </button>
                <button
                    type="button"
                    className={styles.primaryButton}
                    disabled={submitting}
                    onClick={onConfirm}
                >
                    {submitting ? (
                        <LoaderCircle className={styles.spin} size={16} aria-hidden />
                    ) : (
                        <Sparkles size={16} aria-hidden />
                    )}
                    {submitting ? '正在提交…' : '确认，去支付'}
                </button>
            </div>
        </Modal>
    );
}
